import React from 'react';
import {Carousel} from 'react-materialize';

export const Slideshow = (props) => {
    const {
        title,
        theme,
        images,
    } = props;

    const screenMin900px = window.matchMedia("max-width: 900px");

    let shift = 0;
    let padding = 0;

    if(screenMin900px.matches) {
        shift = 128;
        padding = 50;
    }
    else {
        shift = 64;
        padding = 25;
    }

    const screenMin500px = window.matchMedia("max-width: 500px");
    if(screenMin500px.matches) {
        shift = 0;
        padding = 0;
    }

    return (
        <section className={`slideshow ${theme ? theme : ''}`}>
            <h2 className="slideshow-title">{title}</h2>
            <section className="slideshow-carousel">
                {images && (
                    <Carousel
                        carouselId='carousel-1'
                        images={images}
                        centerImages={true}
                        options={{
                            dist: -100,
                            duration: 200,
                            fullWidth: false,
                            indicators: false,
                            noWrap: false,
                            numVisible: 3,
                            onCycleTo: null,
                            padding: padding,
                            shift: shift
                        }}
                    />
                )}
            </section>
        </section>
    );
};